import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import DevelopmentStatussContent from './DevelopmentStatussContent';
import TileHeader from '../../components/TileHeader/TileHeader';
import NewDevelopmentStatusModal from './NewDevelopmentStatusModal';
import DeleteDevelopmentStatusModal from './DeleteDevelopmentStatusModal';
// api
// import { getAllDevelopmentStatuss } from '../../api/developmentStatuss';

import { getDevelopmentStatuss } from '../../api/developmentStatuss';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';
import { toaster } from '../../helpers/toaster';

const DevelopmentStatuss = ({
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(true);

  const [developmentStatussList, setDevelopmentStatussList] = useState(null);
  const [openNewDevelopmentStatusModal, setOpenNewDevelopmentStatusModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [openDevelopmentStatusModal, setOpenDevelopmentStatusModal] = useState(false);
  const [detailModalMode, setDetailModalMode] = useState("create");
  const [developmentStatus, setDevelopmentStatus] = useState(null);

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Development status report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('developmentStatus')
      .then(({ task_id }) => {
        toaster('Generating development status report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };

  const refreshDevelopmentStatussList = async () => {
    
    setLoading(true);
    let data = await getDevelopmentStatuss();
    setDevelopmentStatussList(data); 
    if(data){
      setLoading(false);
    }
  }
  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const closeModal = () => {
    setOpenDevelopmentStatusModal(false);
    setDevelopmentStatus(null);
  };
  
  const addNewDevelopmentStatus = () => {
    openDevelopmentStatusModal(true);
  };

  useEffect(async () => {
    refreshDevelopmentStatussList();
  }, []);

  return (
    <Container>
      <ContentContainer>
        <TileHeader 
            title="Development Status"
            subtitle="A list of all development statuses."
            size="lg"
        />

        
				

        <DevelopmentStatussContent
          developmentStatussList={developmentStatussList}
          setOpenNewDevelopmentStatusModal={setOpenNewDevelopmentStatusModal}
          onDeleteClicked={showDeleteConfirm}
          setOpenNewDevelopmentStatusModal={setOpenDevelopmentStatusModal}
          setDetailModalMode={setDetailModalMode}
          setDevelopmentStatus={setDevelopmentStatus}
          setMode={setDetailModalMode}
          onGenerateReport={() => setOpenReportModal(true)}
          reportStatus={reportStatus}
          />

        <NewDevelopmentStatusModal
          open={openDevelopmentStatusModal}
          developmentStatusData={developmentStatus}
          refreshList={refreshDevelopmentStatussList}
          onClose={closeModal}
          mode={detailModalMode}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />
        <DeleteDevelopmentStatusModal
          open={openDeleteModal}
          refreshList={refreshDevelopmentStatussList}
          onClose={() => setOpenDeleteModal(false)}
          developmentStatusList={developmentStatussList}
          deleteItem={deleteItem}
        />
        
      </ContentContainer>
    </Container>
  );
};

export default DevelopmentStatuss;